export default __webpack_public_path__ + "static/media/zdj2.eaa79b22.JPG";